import { Profile } from 'app/redux/Profile/model'
import { configName } from 'config'
import { NEBFPensionCalculations } from '.'
import { NEBFLocal697PensionCalculations } from './Local697'

function makeNEBFComputer(profile: Profile, pensionText: string = 'NEBF') {

  if (configName === '697') {
    return new NEBFLocal697PensionCalculations(profile, pensionText)
  }

  return new NEBFPensionCalculations(profile, pensionText)
}

export {
  makeNEBFComputer
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/NEBF/Factory.ts